import * as React from 'react';
import { VoidFunc } from 'types/types';

import './TitleBar.pcss';

const TitleBar = (props:{onBack:VoidFunc, rightComponent?:any, title:string}) => 
  <div className="titleBar">
    <button onClick={props.onBack}><i className="material-icons">arrow_back</i></button>
    <h1>{props.title}</h1>    
    {props.rightComponent &&
    <div className="right">
      {props.rightComponent}
    </div>
    }
  </div>
;

export { TitleBar };